import moment from "moment";

const FORM_API_BASE_URL = process.env.REACT_APP_FORM_API_BASEURL;
const PRN_API_BASEURL = process.env.REACT_APP_PRN_API_BASEURL;

const authToken = localStorage.getItem('authToken');

/**
 * Get form schema
 * 
 * @param {*} id
 * @param {*} token 
 * @returns JSON schema
 */
export async function getSchema(token) {
	return await fetch(`${FORM_API_BASE_URL}/form-template/${token}?ts=${moment().unix()}`, {
		headers: {
			'Authorization': authToken
		}
	})
}

/**
 * Save form data
 *  
 * @param {*} data 
 * @returns 
 */
export async function saveData(data) {
	return await fetch(`${FORM_API_BASE_URL}/form-data`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'Authorization': authToken
		},
		body: JSON.stringify(data)
	})
}

/**
 * Get user profile
 */
export async function getUserProfile() {
	return await fetch(`${PRN_API_BASEURL}/account/clinician-profile`, {
		method: 'GET',
		headers: {
			'Authorization': authToken
		}
	})
}

/**
 * Get client clinicians and supervisors
 */
export async function getClientSupervisors(clientId) {
	return await fetch(`${PRN_API_BASEURL}/clients/${clientId}/supervisors`, {
		method: 'GET',
		headers: {
			'Authorization': authToken
		}
	})
}

/**
 * Get diagnostic codes
 */
export async function getDiagnosticCodes() {
	return await fetch(`${PRN_API_BASEURL}/client-form/diagnosis-code`, {
		method: 'GET',
		headers: {
			'Authorization': authToken
		}
	})
}

/**
 * Create a note for clinician
 *  
 * @param {*} data 
 * @returns 
 */
export async function createNote(data) {
	return await fetch(`${PRN_API_BASEURL}/notes`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'Authorization': authToken
		},
		body: JSON.stringify(data)
	})
}
